import {BUSINESS_ROLE, ROLE_LEVEL} from '../../../shared/constants/AppConst';

export const checkPermission = (permittedrole, userRole) => {
  if (!userRole) return false;
  if (permittedrole === BUSINESS_ROLE.PUBLIC) return true;
  return ROLE_LEVEL[userRole] >= ROLE_LEVEL[permittedrole];
};

export const normalizeRole = (role, defaultRole) => {
  return BUSINESS_ROLE[role] ?? defaultRole;
};
